import React, { Component } from 'react'
import {
  Button,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col
} from 'reactstrap'
import { withNamespaces } from 'react-i18next'
import styled from 'styled-components'

import StyledTextarea from '../Forms/Textarea'
import StyledButton from '../Forms/Button'

const StyledModalContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 30px 35px 30px;

  font-family: 'Open Sans', sans-serif;
  font-weight: 500;
`

const StyledTitle = styled.div`
  margin-bottom: 30px;
  font-size: 13px;
  text-align: center;
  color: #19233c;
  text-transform: uppercase;
`

const ModalFooterWrapper = styled(ModalFooter)`
  padding-bottom: 0 !important;
  border: none !important;

  button ::first-letter {
    text-transform: uppercase;
  }
`

const StyledRadioContainer = styled.div`
  display: flex;
  flex-direction: column;

  margin-bottom: 10px;

  & > label {
    margin-bottom: 5px;

    & > input {
      margin-right: 5px;
    }
  }
`

class Feedback extends Component {
  constructor(props) {
    super(props)

    this.state = {
      comment: '',
      selectedSeverity: props.severity
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isOpen !== nextProps.isOpen) {
      this.setState({
        selectedSeverity: nextProps.severity
      })
    }
  }

  changeSeverity = (ev) => {
    const { value } = ev.target

    this.setState({
      selectedSeverity: value
    })
  }

  changeComment = (ev) => {
    const { value } = ev.target

    this.setState({
      comment: value
    })
  }

  sendSeverity = () => {
    const { changeSeverityHandler } = this.props
    const { comment, selectedSeverity } = this.state

    changeSeverityHandler({ comment, severity: +selectedSeverity })
    this.closeModal()
  }

  closeModal = () => {
    this.setState(
      {
        comment: '',
        selectedSeverity: 0
      },
      () => {
        this.props.toggle()
      }
    )
  }

  render() {
    const { isOpen, t } = this.props
    const { selectedSeverity, comment } = this.state

    return (
      <React.Fragment>
        <Modal
          isOpen={isOpen}
          toggle={this.props.toggle}
          contentClassName="styled_modal_content"
          onOpened={this.setInitialValues}
        >
          <StyledModalContent>
            <StyledTitle>{t('severity:wantToChange')}</StyledTitle>
            {isOpen && (
              <form>
                <div>
                  <StyledRadioContainer onChange={this.changeSeverity}>
                    <label htmlFor="contactChoice1">
                      <input
                        onChange={this.changeSeverity}
                        type="radio"
                        id="contactChoice1"
                        name="contact"
                        value={0}
                        defaultChecked={selectedSeverity === 0}
                      />
                      {t('severity:0')}
                    </label>
                    <label htmlFor="contactChoice2">
                      <input
                        onChange={this.changeSeverity}
                        type="radio"
                        id="contactChoice2"
                        name="contact"
                        value={1}
                        defaultChecked={selectedSeverity === 1}
                      />
                      {t('severity:1')}
                    </label>
                    <label htmlFor="contactChoice3">
                      <input
                        onChange={this.changeSeverity}
                        type="radio"
                        id="contactChoice3"
                        name="contact"
                        value={2}
                        defaultChecked={selectedSeverity === 2}
                      />
                      {t('severity:2')}
                    </label>
                  </StyledRadioContainer>

                  <Row>
                    <Col sm={12}>
                      <StyledTextarea
                        type="textarea"
                        input={{
                          value: comment,
                          name: 'comment',
                          id: 'comment',
                          onChange: this.changeComment
                        }}
                        label={t('tickets:comment')}
                      />
                    </Col>
                  </Row>
                </div>
              </form>
            )}

            <ModalFooterWrapper>
              <StyledButton onClick={this.closeModal} outline bgColor="#fff">
                {t('common:cancel')}
              </StyledButton>
              <StyledButton onClick={() => this.sendSeverity()}>
                {t('common:change')}
              </StyledButton>
            </ModalFooterWrapper>
          </StyledModalContent>
        </Modal>
      </React.Fragment>
    )
  }
}

Feedback.defaultProps = {
  initialRate: 0,
  allowToClose: true,
  loading: false
}

export default withNamespaces()(Feedback)
